import { storageService } from '@/services'
import { makeUser } from '@/util/apiHelper'
import { INVALID_CAPTCHA, NEED_CAPTCHA } from '~/services/_api/helpers/_constants'

export const state = () => ({
  errorsRegister: {}, // { message: { email: 'user_exists' } } | 'need_captcha'
})

export const mutations = {
  set_registerErrors: (state, errorsRegister) => {
    state.errorsRegister = errorsRegister
  },
}

export const actions = {
  act_register({ commit, dispatch }, {
    password,
    type,
    is_accept,
    language,
    promokey,
    email = null,
    phone_code = null,
    phone = null,
    recaptchaToken = null,
  }) {
    return new Promise((resolve, reject) => {
      commit('user/auth_request', null, { root: true })
      this.$api.auth.register({
        password,
        type,
        is_accept,
        language,
        promokey,
        email,
        phone_code,
        phone,
        recaptchaToken,
      })
        .then(resp => {
          dispatch(
            'registerBonus/actSet_activatedBonusesCodesFromRegister',
            { promotionsCodes: resp?.data?.promotionsCodes },
            { root: true }
          )
          const errorsRegister = resp.data.errors
          commit('set_registerErrors', errorsRegister)
          if (resp.data.status && resp.data.user) {
            storageService.removeUtm()
            const token = resp.data.user.token
            const user = resp.data.user
            storageService.saveToken(token)
            // this.$api.$commonToken = token
            commit('user/auth_success', { token, user }, { root: true })

            const profileRequest = this.$api.profile.profileInfo()

            profileRequest.then(profileResponce => {
              const userData = makeUser(profileResponce.data.user)

              commit(
                'user/SET_PROFILE_INFO',
                { user: userData, userDataStatus: profileResponce.data.status, abTests: profileResponce.data.ab_tests },
                { root: true }
              )

              return profileRequest
            })

            resolve(resp)
          }
          reject(errorsRegister)
        })
        .catch(error => {
          commit('user/auth_error', error, { root: true })
          storageService.removeToken()
          reject(error)
        })
    })
  },

  async act_migrationRegister({ commit, dispatch }, { token, eventId, isBanner }) {
    try {
      const response = await this.$api.auth.migrationRegister({ token, eventId, isBanner })
      const { status, user, errors } = response?.data

      if (!status || errors) {
        throw new Error(Object.values(errors)?.[0])
      }
      
      if (status && user?.token) {
        storageService.removeUtm()
        storageService.saveToken(user.token)
        commit('user/auth_success', { token: user.token, user }, { root: true })
        const profileResponse = await this.$api.profile.profileInfo()
        const userData = makeUser(profileResponse.data.user)
        commit(
          'user/SET_PROFILE_INFO',
          { user: userData, userDataStatus: profileResponse.data.status, abTests: profileResponse.data.ab_tests },
          { root: true }
        )
      }

      return response
    }
    catch (error) {
      console.error(error)
      throw error
    }
  },
}

export const getters = {
  get_registerErrors: state => state.errorsRegister || '',
  get_isCaptchaRequired: state => state.errorsRegister === NEED_CAPTCHA || state.errorsRegister === INVALID_CAPTCHA,
}
